module.exports = __webpack_public_path__ + "article-7051a3ee/headhunter-deae5cf0141549f6bf404869ed66412b.jpeg";